import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Root route component: single mount point for app-wide UI providers that must
 * live inside the router tree (`SkeletonTheme`, `Toaster`). `QueryClientProvider`
 * lives one level up in `main.tsx`. Mirrors `apps/admin/src/App.tsx`.
 */
export default function App(): ReactElement {
  return (
    <SkeletonTheme baseColor="#1e293b" highlightColor="#334155">
      <Outlet />
      <Toaster position="bottom-right" theme="dark" richColors closeButton />
    </SkeletonTheme>
  );
}
